import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FooterComponent } from './footer.component';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    FooterComponent
  ],
  providers: [
  ],
  declarations: [
    FooterComponent
  ]
})
export class FooterModule { }
